import { SceneService } from './../scene.service';
import { BoundingBox2 } from './../../share/boundingbox2';
import { PerspectiveCamera } from 'three';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { RendererService } from '../renderer.service';

@Component({
  selector: 'ng3-perspective-camera',
  templateUrl: './perspective-camera.component.html',
  styleUrls: ['./perspective-camera.component.css']
})
export class PerspectiveCameraComponent implements OnInit {
  readonly camera = new PerspectiveCamera(
    45,
    this.size.left / this.size.bottom,
    0.01,
    1e10,
  );
  @Output() changed = new EventEmitter<void>();
  @Input()
  get size(): BoundingBox2 {
    return this.scene.size;
  }
  set size(b: BoundingBox2) {
    this.scene.resize(b);
  }
  @Input()
  z = 100;
  constructor(
    private scene: SceneService,
    private renderer: RendererService
  ) {
    this.camera.position.z = this.z;
    this.camera.lookAt(this.scene.scene.position);
    this.scene.size$.subscribe(
      (b) => this.updateCameraFov(b),
      (e) => console.error(e)
    );
  }

  private updateCameraFov(b: BoundingBox2) {
    this.camera.fov = 50;
    this.camera.aspect = b.left / b.bottom;
    this.camera.near = 1;
    this.camera.far = 1;
    this.changed.emit();
    this.renderer.render();

  }
  ngOnInit() {
    // console.log('camera init');

  }
}
